<!--
/**
* @name: List.vue
* @description: 品牌管理-修改品牌信息
* @author: 杨波
* @create: 2020/09/02 17:06:58
* @update: 2020/09/302 17:06:58
*/
-->

<template>
  <y-view :loading="isLoading">
    <template v-if="!isView">
      <y-form titleAlign="right" titleWidth="100px" contentWidth="100%">
        <y-form-item title="选择品牌:">
          <k-input disabled :class="css.inputW" placeholder="请输入品牌名称" block v-model="editPara.goodsBrandName"></k-input>
        </y-form-item>
        <y-form-item title="品牌别名:">
          <k-input :class="css.inputW" placeholder="请输入，前端的品牌展示此名称" block v-model="editPara.anotherName"></k-input>
        </y-form-item>
        <y-form-item title="英文名称:">
          <k-input :class="css.inputW" placeholder="请输入，会按照此英文名称进行品牌排序" block v-model="editPara.englishName"></k-input>
        </y-form-item>
        <y-form-item title="品牌封面图:" align="top">
          <div class="row">
            <y-upload-file :uploadUrl="uploadUrl" @uploaded="onUploadedCoverImage" fileType="image" v-if="coverImageList.length == 0"></y-upload-file>
            <y-image
              @delete="onDeleteCoverImage"
              v-dragging="{ list: coverImageList, item: img, group: 'image' }"
              v-for="(img, index) in coverImageList"
              :key="index"
              :index="index"
              :src="img"
            ></y-image>
          </div>
          <div class="mt-1">（说明：最多上传1张，大小不超过3 M，图片尺寸为750*750）</div>
        </y-form-item>
        <y-form-item title="品牌背景图:" align="top">
          <div class="row">
            <y-upload-file :uploadUrl="uploadUrl" @uploaded="onUploadedBackgroundImage" fileType="image" v-if="backgroundImageList.length == 0"></y-upload-file>
            <y-image
              @delete="onDeleteBackgroundImage"
              v-dragging="{ list: backgroundImageList, item: img, group: 'image' }"
              v-for="(img, index) in backgroundImageList"
              :key="index"
              :index="index"
              :src="img"
            ></y-image>
          </div>
          <div class="mt-1">（说明：最多上传1张，大小不超过3 M，图片尺寸为750*750）</div>
        </y-form-item>
        <y-form-item title="品牌授权说明书:" align="top">
          <div class="row">
            <y-upload-file :uploadUrl="uploadUrl" @uploaded="onUploaded" fileType="image" v-if="imgList.length == 0"></y-upload-file>
            <y-image @delete="onDelete" v-dragging="{ list: imgList, item: img, group: 'image' }" v-for="(img, index) in imgList" :key="index" :index="index" :src="img"></y-image>
          </div>
          <div class="mt-1">（说明：最多上传1张，大小不超过3 M，图片尺寸为750*750）</div>
        </y-form-item>
        <y-form-item title="品牌简介:">
          <k-input tag="textarea" :class="css.inputW" placeholder="请输入品牌简介" block clearable v-model="editPara.brandResume"></k-input>
        </y-form-item>
        <y-form-item title="品牌描述:" align="top">
          <div :class="css.ueditorW">
            <ueditor v-model="editPara.brandDescribe"></ueditor>
          </div>
        </y-form-item>
      </y-form>
    </template>
    <div slot="bottom" v-if="!isView">
      <k-button @click="onReset" v-if="isEdit">重置</k-button>
      <k-button @click="onCancel(true, false)" v-else>取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus">保存</k-button>
    </div>
  </y-view>
</template>

<script>
import { NESTLE_GOODS_BACK_SERVER_GOODS_BRAND_EXTEND_DETAIL, NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS, NESTLE_GOODS_BACK_SERVER_GOODS_BRAND_EXTEND_UPDATE } from "@/assets/modules/apiList";
const initEditPara = () => ({
  goodsBrandCode: "",
  goodsBrandName: "",
  brandManual: "",
  anotherName: "",
  englishName: "",
  brandResume: "",
  brandDescribe: "",
});
export default {
  data() {
    return {
      isLoading: false,
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
      editPara: initEditPara(),
      imgList: [],
      coverImageList: [],
      backgroundImageList: [],
      isSaving: false,
      isView: false,
      isEdit: false,
      originData: {},
    };
  },
  computed: {
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (!this.isView) {
        let goodsBrandName = para.goodsBrandName.toString().replace(/\s*/g, "");
        if (!goodsBrandName || !para.brandResume || !para.brandDescribe) {
          status = true;
        }
      }
      return status;
    },
  },
  methods: {
    getBrandDetail(code) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_BRAND_EXTEND_DETAIL,
        para: { goodsBrandCode: code },
      })
        .then((res) => {
          this.originData = JSON.parse(JSON.stringify(res));
          this.editPara = res;
          this.isLoading = false;
          if (res.brandManual) {
            this.imgList.push(res.brandManual);
          }
          if (res.coverImage) {
            this.coverImageList.push(res.coverImage);
          }
          if (res.backgroundImage) {
            this.backgroundImageList.push(res.backgroundImage);
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onUploaded(data) {
      this.imgList = [];
      this.imgList.push(data.data[0].url);
    },
    onUploadedCoverImage(data) {
      this.coverImageList = [];
      this.coverImageList.push(data.data[0].url);
    },
    onUploadedBackgroundImage(data) {
      this.backgroundImageList = [];
      this.backgroundImageList.push(data.data[0].url);
    },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "brandManagement",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onReset() {
      this.editPara = JSON.parse(JSON.stringify(this.originData));
    },
    onSave() {
      const { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      para.brandManual = this.imgList.join(",");
      para.coverImage = this.coverImageList.join(",");
      para.backgroundImage = this.backgroundImageList.join(",");

      if (para.englishName) {
        let regName = /^[a-zA-Z0-9 ]+$/;
        if (!regName.test(para.englishName)) {
          return tip("只能输入英文字母和数字，可以有空格");
        }
      }
      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: this.isEdit ? NESTLE_GOODS_BACK_SERVER_GOODS_BRAND_EXTEND_UPDATE : "",
        para,
      })
        .then((res) => {
          this.isSaving = false;
          this.isLoading = false;
          tip("操作成功");
          this.onCancel(true, true);
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    onDelete(obj) {
      console.log(obj);
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.imgList.splice(obj.index, 1);
        },
      });
    },
    onDeleteCoverImage(obj) {
      console.log(obj);
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.coverImageList.splice(obj.index, 1);
        },
      });
    },
    onDeleteBackgroundImage(obj) {
      console.log(obj);
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.backgroundImageList.splice(obj.index, 1);
        },
      });
    },
  },
  created() {
    const { goodsBrandCode, edit, view } = this.$route.query;
    if (goodsBrandCode) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getBrandDetail(goodsBrandCode);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.editPara = initEditPara();
    this.imgList = [];
    this.coverImageList = [];
    this.backgroundImageList = [];
    const { goodsBrandCode, edit, view } = to.query;
    if (goodsBrandCode) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getBrandDetail(goodsBrandCode);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
    next();
  },
};
</script>

<style lang="postcss" module="css">
.inputW {
  width: 400px !important;
}
.ueditorW {
  width: 800px !important;
}
</style>
